import axios from 'axios';

const RAW_BASE = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';
const API_BASE = RAW_BASE.replace(/\/+$/, '');

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
  // timeout: 10000,
});

export default api;
